import * as React from "react";
import Container from "@amzn/awsui-components-react/polaris/container";
import Header from "@amzn/awsui-components-react/polaris/header";
import CopyToClipboard from "@amzn/awsui-components-react/polaris/copy-to-clipboard";
import { CustomerJourneyResponse } from "./journey-types";

interface CustomerInfoHeaderProps {
    data: CustomerJourneyResponse;
}

function displayValue(value: string | null | undefined): string {
    if (value === null || value === undefined || value.trim() === "" || value === "null") {
        return "N/A";
    }
    return value;
}

function InfoCard({ icon, label, value }: { icon: string; label: string; value: string | null | undefined }) {
    const display = displayValue(value);
    const isNA = display === "N/A";

    return (
        <div style={{
            padding: "12px 16px",
            backgroundColor: isNA ? "#f9fafb" : "#ffffff",
            borderRadius: "10px",
            border: `1px solid ${isNA ? "#e9ebed" : "#d1e3f8"}`,
            transition: "all 0.2s",
            minHeight: "70px",
        }}>
            <div style={{ display: "flex", alignItems: "center", gap: "6px", marginBottom: "6px" }}>
                <span style={{ fontSize: "14px" }}>{icon}</span>
                <span style={{ fontSize: "11px", fontWeight: 600, color: "#5f6b7a", textTransform: "uppercase", letterSpacing: "0.3px" }}>
                    {label}
                </span>
            </div>
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                <span style={{
                    fontSize: "13px",
                    fontWeight: isNA ? 400 : 500,
                    color: isNA ? "#9ba7b6" : "#16191f",
                    fontFamily: isNA ? "inherit" : "monospace",
                    wordBreak: "break-all",
                }}>
                    {display}
                </span>
                {!isNA && (
                    <CopyToClipboard
                        copyButtonText=""
                        copySuccessText="✓"
                        copyErrorText="!"
                        textToCopy={display}
                        variant="icon"
                    />
                )}
            </div>
        </div>
    );
}

const CustomerInfoHeader: React.FC<CustomerInfoHeaderProps> = ({ data }) => {
    return (
        <Container
            header={
                <Header variant="h2">
                    <span style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                        <span style={{ fontSize: "20px" }}>👤</span>
                        Customer Profile
                    </span>
                </Header>
            }
        >
            <div style={{
                display: "grid",
                gridTemplateColumns: "repeat(4, 1fr)",
                gap: "12px",
                padding: "8px 0",
            }}>
                <InfoCard icon="👤" label="Name" value={data.name} />
                <InfoCard icon="📧" label="Email" value={data.email} />
                <InfoCard icon="📱" label="Phone" value={data.phoneNumber} />
                <InfoCard icon="🆔" label="Customer ID" value={data.customerId} />

                <InfoCard icon="🔑" label="Person ID" value={data.personId} />
                <InfoCard icon="📋" label="Profile ID" value={data.profileId} />
                <InfoCard icon="🎂" label="Date of Birth" value={data.dateOfBirth} />
                <InfoCard icon="⚧" label="Gender" value={data.gender} />

                <InfoCard icon="🏥" label="Insurance" value={data.insurancePlan} />
                <InfoCard icon="👨‍⚕️" label="Doctor" value={data.primaryDoctor} />
                <InfoCard icon="🤰" label="Pregnant/Nursing" value={data.pregnantOrNursing} />
                <InfoCard icon="🏠" label="Address" value={data.residentialAddress} />
            </div>
        </Container>
    );
};

export default CustomerInfoHeader;
